// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"f63561ba","58":"a78bf915","117":"b706d1ab","160":"475c7482","480":"9bf2a161","543":"a22f1f40","757":"9082595f"}[chunkId] + ".chunk.css";
};